import { CustomFieldAttributeValue } from 'apis/customFields';

/** Checks whether given custom field value is empty. */
export function isCustomFieldValueEmpty(
  value?: CustomFieldAttributeValue,
): boolean {
  return (
    value?.value === undefined ||
    (value.data_type === 'string' && value.value === '') ||
    (value.data_type === 'string_list' && value.value.length === 0)
  );
}
